// removed by extract-text-webpack-plugin
module.exports = {"StepFour":"StepFour-module__StepFour__23-sT","InputWrapper":"StepFour-module__InputWrapper__1E1_b","Footer":"StepFour-module__Footer__1PlIE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/EmailRegisterInner/Steps/StepFour/StepFour.module.css
// module id = 1753
// module chunks = 31